"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_flowright_1 = __importDefault(require("lodash.flowright"));
const withDeprecated_1 = __importDefault(require("../../utils/withDeprecated"));
const style_1 = __importDefault(require("./style"));
const Button = ({ children, onClick, classes, disabled, className, dataCy, ...otherprops }) => (jsx_runtime_1.jsx("button", Object.assign({ "data-cy": dataCy || 'atomic-button', onClick: onClick, className: classnames_1.default(classes.root, className), disabled: disabled }, otherprops, { children: children }), void 0));
exports.Button = Button;
exports.Button.propTypes = {
    children: prop_types_1.default.node.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    classes: prop_types_1.default.object.isRequired,
    disabled: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    dataCy: prop_types_1.default.string
};
exports.Button.defaultProps = {
    disabled: false,
    className: null,
    dataCy: ''
};
const COMPONENT_CONFIG = {
    obsolete: '<Button />',
    new: '<Pushbutton /> in surface'
};
exports.default = lodash_flowright_1.default(withDeprecated_1.default(COMPONENT_CONFIG), react_jss_1.default(style_1.default))(exports.Button);
//# sourceMappingURL=index.js.map